import React from "react";
import "./Overlay.css";
import {FaFacebookF} from "react-icons/fa"
import {IoLogoGoogleplus} from "react-icons/io"
import {FaLinkedinIn} from "react-icons/fa"
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";

const Overlay = (props) => {

  useEffect(() => {
    Aos.init({duration: 2000});
  }, []);

  return (
    <div data-aos="zoom-in" className="overlay__container">
      <img src={props.img} alt={props.alt} className="overlay__image" />
      <div className="overlay overlayTop">
        <div className="overlay__text">
          <span>(727) 447-4248</span><br />
          <span>info@lincourtpharmacy.com</span>
          <div className="overlay__socials">
            <FaFacebookF className="overlay__socials__icons"/>
            <IoLogoGoogleplus className="overlay__socials__icons"/>
            <FaLinkedinIn className="overlay__socials__icons"/>
          </div>
        </div>
      </div>
      <div className="overlay__img__container__bottom">
        <div className="overlay__img__container__bottom__title">
          {props.title}
        </div>
        <div className="overlay__img__container__bottom__occupancy">
          {props.occupancy}
        </div>
      </div>
    </div>
  );
};

export default Overlay;
